export default __webpack_public_path__ + "9edbedcf153e12a64c6a9f278a38994a.svg";